import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_736b5617-324a-4027-a0b5-949393e5cf90/artifacts/te4le6nd_Untitled%20design.png";

export function LegalPage({ title, kind }) {
  const isTerms = kind === 'terms';
  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid={`legal-${kind}-page`}>
      <header className="bg-white border-b border-[#E2E8F0] py-4">
        <div className="container-custom flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3"><img src={LOGO_URL} alt="DCA" className="h-10 w-auto" /></Link>
          <Link to="/" className="text-sm text-[#475569] hover:text-[#1D4ED8] flex items-center gap-2"><ArrowLeft size={16} /> Back to Website</Link>
        </div>
      </header>
      <main className="container-custom py-12 max-w-3xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-[#0A0F1C] mb-2" data-testid={`legal-${kind}-title`}>{title}</h1>
        <p className="text-sm text-[#94A3B8] mb-8">Last updated: Feb 2026</p>

        <div className="prose prose-slate max-w-none space-y-5 text-[#1F2937]">
          <section>
            <h2 className="text-xl font-bold text-[#0A0F1C]">1. Overview</h2>
            <p className="text-sm leading-relaxed">
              This document is provided by David C. Ashley Enterprises Inc. (&quot;DCA Enterprises&quot;, &quot;we&quot;, &quot;us&quot;).
              By using DCAEnterprisesInc.com, the client portal, or any of David Ashley&rsquo;s coaching brands (SEG Career,
              CareerSupport.io, Purpose Fit, Purpose Transformation), you agree to the terms below.
            </p>
          </section>

          {isTerms ? (
            <>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">2. Coaching Services</h2>
                <p className="text-sm leading-relaxed">
                  Coaching sessions, programs, and resources are educational and do not constitute legal, financial,
                  medical, or therapeutic advice. Results vary; we do not guarantee specific outcomes.
                </p>
              </section>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">3. Payments &amp; Refunds</h2>
                <p className="text-sm leading-relaxed">
                  Payments are processed by Stripe or PayPal. Refund eligibility is described per program at the time
                  of purchase. Recurring memberships can be cancelled any time before the next billing date.
                </p>
              </section>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">4. Acceptable Use</h2>
                <p className="text-sm leading-relaxed">
                  You may not abuse, scrape, reverse-engineer, or attempt to gain unauthorized access to the portal.
                  Sensitive admin actions are logged in our audit trail.
                </p>
              </section>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">5. Contact</h2>
                <p className="text-sm leading-relaxed">Questions? Email <a className="text-[#1D4ED8] hover:underline" href="mailto:info@DCAEnterprisesInc.com">info@DCAEnterprisesInc.com</a>.</p>
              </section>
            </>
          ) : (
            <>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">2. What we collect</h2>
                <p className="text-sm leading-relaxed">
                  Name, email, phone number, payment details (via Stripe/PayPal. We never store full card numbers),
                  intake form responses, and session activity inside the client portal.
                </p>
              </section>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">3. How we use it</h2>
                <p className="text-sm leading-relaxed">
                  To deliver coaching, send booking confirmations and reminders, run programs you opt into, and improve
                  the platform. We do not sell your personal data to third parties.
                </p>
              </section>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">4. Your rights</h2>
                <p className="text-sm leading-relaxed">
                  You can edit your profile, change your password, and manage notification preferences at any time from{' '}
                  <Link to="/portal/settings" className="text-[#1D4ED8] hover:underline">Account Settings</Link>.
                  You may request deletion of your data by emailing info@DCAEnterprisesInc.com.
                </p>
              </section>
              <section>
                <h2 className="text-xl font-bold text-[#0A0F1C]">5. Security</h2>
                <p className="text-sm leading-relaxed">
                  Passwords are stored as bcrypt hashes. Sessions use httpOnly cookies. Auth endpoints are rate-limited
                  to deter brute-force attempts.
                </p>
              </section>
            </>
          )}
        </div>
      </main>
    </div>
  );
}

export function TermsPage() { return <LegalPage title="Terms of Service" kind="terms" />; }
export function PrivacyPage() { return <LegalPage title="Privacy Policy" kind="privacy" />; }
export default TermsPage;
